import { validaEmails, validaNames } from "../../helpers/forms/Validation";
import { UPDATE_DEPARTMENT, RESET_DEPARTMENT, SET_DEPARTMENTS } from "./actionTypes";
import * as Yup from "yup";

const departmentBase = {
    id: null,
    name: '',
    code: '',
}

const departmentsBase = {
    departaments: [],
    meta: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 20,
        to: 1,
        total: 0
    },
}
const initialState = {
    department: { ...departmentBase },
    departments: { ...departmentsBase },
    validations: {
        name: validaNames(),
        code: Yup.string().required('El identificador es obligatorio'),
    }
};

const department = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_DEPARTMENT:
            // Actualizar el estado
            return {
                ...state,
                department: action.payload
            };
        case RESET_DEPARTMENT:
            return {
                ...state,
                department: { ...departmentBase }
            };
        case SET_DEPARTMENTS:
            return {
                ...state,
                departments: action.payload
            };
        default:
            return state;
    }
};

export default department;
